import type {
  AccommodationAvailabilityCriteria,
  GraphQL,
} from '@libs/trip-planner-interfaces';
import { normalizeDateOnlyString } from '@libs/utils';

import { getRecipeQL } from './recipeQL';

export function getCheapestHotelStayRequestQL(
  criteria: AccommodationAvailabilityCriteria
): GraphQL.CheapestHotelStayRequestQL {
  return {
    recipe: getRecipeQL({
      userCriteria: criteria.userCriteria.recipe,
      businessCriteria: criteria.businessCriteria,
    }),
    ingredientIndex: criteria.userCriteria.ingredientIndex,
    hotelCode: criteria.userCriteria.productCode,
    day: normalizeDateOnlyString(criteria.userCriteria.day),
  };
}
